import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-blue",
  "use": "icon-arrow-down-blue-usage",
  "viewBox": "0 0 9.4 6.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.4 6.1\" id=\"icon-arrow-down-blue\"><path class=\"st0\" d=\"M4.8 6.1L0 1.4 1.4 0l3.4 3.3L8 .1l1.4 1.4-4.6 4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol